"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFullReturn = exports.isCancelled = exports.getTitle = exports.getTimezone = exports.getReturnTitle = exports.getReturnText = exports.getReturnHeader = exports.getPriceText = exports.getListItemDateText = exports.getIntervaledStages = exports.getInsuranceButtonText = exports.getFadeColors = exports.getDescriptionStagesText = exports.getCurrentStage = exports.getCollapsedTitleContent = exports.getCancelledText = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _differenceInHours = _interopRequireDefault(require("date-fns/differenceInHours"));

var _subDays = _interopRequireDefault(require("date-fns/subDays"));

var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));

var _isEqual = _interopRequireDefault(require("date-fns/isEqual"));

var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));

var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));

var _localization = require("@lt/localization");

var _currency = require("../../../utils/currency");

var _date = require("../../../utils/date");

var _number = require("../../../utils/number");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var rgbaToString = function rgbaToString(color, alpha) {
  return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(alpha, ")");
};

var getFadeColors = function getFadeColors(baseColor, count) {
  var alphaStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var alphaStop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.05;

  if (!count) {
    return [];
  }

  var alphaStep = (0, _number.toDecimal)((alphaStart - alphaStop) / count);
  var colorArray = [];

  for (var i = 0; i < count; i += 1) {
    var alpha = (0, _number.toDecimal)(alphaStart - i * alphaStep);
    var strColor = rgbaToString(baseColor, alpha < alphaStop ? alphaStop : alpha);
    colorArray.push(strColor);
  }

  return colorArray;
};

exports.getFadeColors = getFadeColors;

var isFullReturn = function isFullReturn(type) {
  return type === 'full';
};

exports.isFullReturn = isFullReturn;

var getReturnTitle = function getReturnTitle(price, interval) {
  if (price === 0) {
    return '';
  }

  var dateText = (0, _date.formatDate)(interval.endDateISO, 'd MMM H:mm');
  return "".concat(_localization.i18n.t('filters.prices.before'), " ").concat(dateText);
};

exports.getReturnTitle = getReturnTitle;

var getReturnText = function getReturnText(price, interval, fullReturn, isHotelOnly) {
  var endDateText = "".concat((0, _date.formatDate)(new Date(interval.endDateISO), 'd MMMM, HH:mm'), " ").concat(_localization.i18n.t('cancellationPolicy.timezone'), " ").concat(getTimezone(new Date(interval.endDateISO)));
  var startDateText = "".concat((0, _date.formatDate)(new Date(interval.startDateISO), 'd MMMM, HH:mm'), " ").concat(_localization.i18n.t('cancellationPolicy.timezone'), " ").concat(getTimezone(new Date(interval.startDateISO)));

  var offerType = _localization.i18n.t('cancellationPolicy.offerType', {
    context: isHotelOnly ? 'hotel' : 'package'
  });

  var tourRules = _localization.i18n.t('cancellationPolicy.tourRules', {
    context: isHotelOnly ? 'hotel' : 'package'
  });

  if (price === 0) {
    return _localization.i18n.t('cancellationPolicy.returnText_startDate', {
      startDateText: startDateText,
      offerType: offerType,
      tourRules: tourRules
    });
  }

  if (fullReturn) {
    return _localization.i18n.t('cancellationPolicy.returnText_full', {
      endDateText: endDateText,
      price: price,
      offerType: offerType
    });
  }

  return _localization.i18n.t('cancellationPolicy.returnText_endDate', {
    endDateText: endDateText,
    price: price,
    offerType: offerType,
    tourRules: tourRules
  });
};

exports.getReturnText = getReturnText;

var getDescriptionStagesText = function getDescriptionStagesText(price, interval, fullReturn, isHotelOnly) {
  var format = isHotelOnly ? 'd MMMM yyyy г., HH:mm' : 'd MMMM yyyy г.';
  var endDateText = (0, _date.formatDate)(interval.endDateISO, format);
  var startDateText = (0, _date.formatDate)(interval.startDateISO, format);

  if (price === 0) {
    return _localization.i18n.t('tariff.cancellationPolicy.nothing', {
      startDateText: startDateText
    });
  }

  if (fullReturn) {
    return "".concat(_localization.i18n.t('tariff.cancellationPolicy.full', {
      endDateText: endDateText
    }), " ").concat(getTimezone(new Date(interval.endDateISO)));
  }

  return "".concat(_localization.i18n.t('tariff.cancellationPolicy.partial', {
    endDateText: endDateText
  }), " ").concat(getTimezone(new Date(interval.endDateISO)));
};

exports.getDescriptionStagesText = getDescriptionStagesText;

var getReturnHeader = function getReturnHeader(price, fullReturn) {
  if (price === 0) {
    return _localization.i18n.t('cancellationPolicy.noReturn');
  }

  if (fullReturn) {
    return _localization.i18n.t('cancellationPolicy.fullReturn');
  }

  return _localization.i18n.t('cancellationPolicy.partialReturn');
};

exports.getReturnHeader = getReturnHeader;

var getPriceText = function getPriceText(price, fullReturn) {
  if (price === 0) {
    return '0 ₽';
  }

  if (fullReturn) {
    return _localization.i18n.t('cancellationPolicy.fullReturn');
  }

  return "".concat((0, _currency.formatCurrency)(price));
};

exports.getPriceText = getPriceText;

var getProgress = function getProgress(startDate, endDate, nowDate) {
  if (!(0, _isValid["default"])(startDate) || !(0, _isValid["default"])(endDate) || !(0, _isValid["default"])(nowDate)) {
    return 0;
  }

  if ((0, _isAfter["default"])(nowDate, endDate)) {
    return 0;
  }

  if ((0, _isBefore["default"])(nowDate, startDate)) {
    return 100;
  }

  var wholeIntervalDays = (0, _differenceInHours["default"])(endDate, startDate);
  var nowIntervalDays = (0, _differenceInHours["default"])(nowDate, startDate);
  return 100 - Math.round(nowIntervalDays / wholeIntervalDays * 100);
};

var getHasNowDateFlag = function getHasNowDateFlag(startDate, endDate, nowDate, index) {
  return (0, _isValid["default"])(startDate) && (0, _isValid["default"])(endDate) && (0, _isBefore["default"])(startDate, endDate) && !(0, _isEqual["default"])(nowDate, endDate) && ((0, _isWithinInterval["default"])(nowDate, {
    start: startDate,
    end: endDate
  }) || index === 0 && (0, _isBefore["default"])(nowDate, startDate));
};

var getIntervaledStages = function getIntervaledStages() {
  var stages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var flightDateISO = arguments.length > 1 ? arguments[1] : undefined;
  var nowDateISO = arguments.length > 2 ? arguments[2] : undefined;
  return stages.map(function (stage, index) {
    var _stages;

    var interval = {
      startDateISO: stage.start_date,
      endDateISO: ((_stages = stages[index + 1]) === null || _stages === void 0 ? void 0 : _stages.start_date) || flightDateISO
    };
    var startDate = new Date(interval.startDateISO);
    var endDate = new Date(interval.endDateISO);
    var nowDate = new Date(nowDateISO);
    var progress = getProgress(startDate, endDate, nowDate);
    var hasNowDate = getHasNowDateFlag(startDate, endDate, nowDate, index);
    return _objectSpread(_objectSpread({}, stage), {}, {
      interval: interval,
      progress: progress,
      hasNowDate: hasNowDate
    });
  });
};

exports.getIntervaledStages = getIntervaledStages;

var getListItemDateText = function getListItemDateText(interval, flightDateISO, isHotelOnly, first) {
  var startDateISO = interval.startDateISO,
      endDateISO = interval.endDateISO;
  var isEndDateFlight = new Date(flightDateISO) === new Date(endDateISO);
  var displayStartDate = (0, _parseISO["default"])(startDateISO);
  var displayEndDate = isHotelOnly || isEndDateFlight || first ? (0, _parseISO["default"])(endDateISO) : (0, _subDays["default"])((0, _parseISO["default"])(endDateISO), 1);
  var format = isHotelOnly ? 'd MMM H:mm' : 'd MMM';
  var dateStartText = (0, _date.formatDate)(displayStartDate, format);
  var dateEndText = (0, _date.formatDate)(displayEndDate, format);
  var isDatesEqual = (0, _isEqual["default"])(new Date(dateStartText), new Date(dateEndText));
  var endDateIsBefore = (0, _isBefore["default"])(displayEndDate, displayStartDate);

  if (endDateIsBefore) {
    return "".concat(_localization.i18n.t('cancellationPolicy.after'), " ").concat(dateStartText);
  }

  if (isDatesEqual) {
    return dateStartText;
  }

  if (first) return "".concat(_localization.i18n.t('filters.prices.before'), " ").concat(dateEndText);
  return "".concat(dateStartText, " \u2013 ").concat(dateEndText);
};

exports.getListItemDateText = getListItemDateText;

var getInsuranceButtonText = function getInsuranceButtonText() {
  var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var insuranceSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return insuranceSelected ? "".concat(_localization.i18n.t('cancellationPolicy.insuranceRemove_desktop')) : "".concat(_localization.i18n.t('cancellationPolicy.insuranceAdd_desktop'), " ").concat((0, _currency.formatCurrency)(price));
};

exports.getInsuranceButtonText = getInsuranceButtonText;

var getCancelledText = function getCancelledText(cancellationDateISO) {
  var date = (0, _parseISO["default"])(cancellationDateISO);

  if (!(0, _isValid["default"])(date)) {
    return '';
  }

  return "".concat(_localization.i18n.t('cancellationPolicy.canceled'), " ").concat((0, _date.formatDate)(date, 'd MMM yyyy'));
};

exports.getCancelledText = getCancelledText;

var isCancelled = function isCancelled(dateISO) {
  return dateISO ? (0, _isValid["default"])((0, _parseISO["default"])(dateISO)) : false;
};

exports.isCancelled = isCancelled;

var getCollapsedTitleContent = function getCollapsedTitleContent(isMobile, isHotelOnly, returnType, currentStageEndDate, cancelled) {
  if (cancelled) return _localization.i18n.t('cancellationPolicy.tourCanceled', {
    context: isHotelOnly ? 'hotel' : 'package'
  });
  var formatDeviceDate = isMobile ? 'd MMM, HH:mm' : 'd MMMM, HH:mm';

  switch (returnType) {
    case 'full':
      return "".concat(_localization.i18n.t('cancellationPolicy.freeCancellation'), " ").concat((0, _date.formatDate)(new Date(currentStageEndDate), formatDeviceDate), " ").concat(getTimezone(new Date(currentStageEndDate)));

    case 'partial':
      return _localization.i18n.t('cancellationPolicy.partialRefund');

    case 'nothing':
      return _localization.i18n.t('cancellationPolicy.nonRefundableTour', {
        context: isHotelOnly ? 'hotel' : 'package'
      });

    default:
      return null;
  }
};

exports.getCollapsedTitleContent = getCollapsedTitleContent;

var getCurrentStage = function getCurrentStage(stages) {
  var currentStage = stages.filter(function (stage) {
    return stage.hasNowDate;
  }).length ? stages.filter(function (stage) {
    return stage.hasNowDate;
  }) : stages;

  if (currentStage === stages) {
    // проверяем за какие пределы выходит дата
    // @ts-ignore
    return (0, _isBefore["default"])(new Date(), new Date(stages[0].start_date)) ? stages[0] : stages[stages.length - 1];
  }

  return currentStage[0];
};

exports.getCurrentStage = getCurrentStage;

var getTitle = function getTitle(currentStage, isHotelOnly) {
  if (!currentStage) return '';

  if (currentStage.return_type === 'full') {
    var format = isHotelOnly ? 'd MMMM, HH:mm' : 'd MMMM';
    var formatEndDate = (0, _date.formatDate)(new Date(currentStage.end_date), format);
    return "".concat(_localization.i18n.t('cancellationPolicy.freeCancellation'), " ").concat(formatEndDate);
  }

  if (currentStage.return_type === 'partial') {
    return "".concat(_localization.i18n.t('cancellationPolicy.partialRefund'));
  }

  if (currentStage.return_type === 'nothing') {
    return "".concat(_localization.i18n.t('cancellationPolicy.nonRefundableTariff'));
  }

  return '';
};

exports.getTitle = getTitle;

var getTimezone = function getTimezone(date) {
  var _date$toString$match;

  if (!date) return '';
  return "(".concat("".concat((_date$toString$match = date.toString().match(/([A-Z]+[+-][0-9].)/)) === null || _date$toString$match === void 0 ? void 0 : _date$toString$match[1], ".00"), ")");
};

exports.getTimezone = getTimezone;